import { createApp } from 'vue'
import App from './App.vue'
import { Quasar, Dialog, Notify, Loading } from "quasar";
import HighchartsVue from "highcharts-vue";
import '@quasar/extras/material-icons/material-icons.css';
import 'quasar/dist/quasar.css';
import lang from './lang'
import { config } from './config'
import router from './router'

createApp(App).use(Quasar, {
    config: {
        brand: config.colors
    },
    lang: lang.es.quasar,
    plugins: {
        Notify,
        Loading,
        Dialog
    },
}).use(HighchartsVue).use(router).mount('#app')
